module.exports = __webpack_public_path__ + "static/media/go.7d490efe.png";